import { useLazyQuery } from '@apollo/client'
import { Region as AwsRegion } from '@faceup/utils'
import { graphql } from '../__generated__'

const query = {
  ReportPasswordDiscovery: graphql(`
    query ReportPasswordDiscoveryQuery($password: GraphQLString!) {
      reportPasswordDiscovery(password: $password) {
        regionId
        institutionId
        reportSourceId
        type
      }
    }
  `),
  ShortlinkDiscovery: graphql(`
    query ShortlinkDiscoveryQuery($shortlink: GraphQLString!) {
      shortlinkDiscovery(shortlink: $shortlink) {
        regionId
        institutionId
        reportSourceId
        type
      }
    }
  `),
  TokenDiscovery: graphql(`
    query TokenDiscoveryQuery($token: GraphQLString!) {
      region: tokenDiscovery(token: $token)
    }
  `),
}

export let region: AwsRegion = AwsRegion.EuWest1

const useRegion = () => {
  const [fetchByReportPassword] = useLazyQuery(query.ReportPasswordDiscovery, {
    fetchPolicy: 'cache-and-network',
  })

  const [fetchByShortlink] = useLazyQuery(query.ShortlinkDiscovery, {
    fetchPolicy: 'cache-and-network',
  })

  const [fetchTokenDiscovery] = useLazyQuery(query.TokenDiscovery, {
    fetchPolicy: 'cache-and-network',
  })

  const discoverByToken = async (token: string) => {
    const { data } = await fetchTokenDiscovery({
      variables: { token },
    })

    if (!data?.region) {
      return null
    }
    region = data.region as AwsRegion

    return data.region as AwsRegion
  }

  const discoverByReportPassword = async (password: string) => {
    const { data } = await fetchByReportPassword({
      variables: { password },
    })

    if (!data?.reportPasswordDiscovery?.regionId) {
      return null
    }
    region = data?.reportPasswordDiscovery?.regionId as AwsRegion

    return data.reportPasswordDiscovery
  }

  const discoverByShortlink = async (shortlink: string) => {
    const { data } = await fetchByShortlink({
      variables: { shortlink },
    })

    if (!data?.shortlinkDiscovery?.regionId) {
      return null
    }

    region = data?.shortlinkDiscovery?.regionId as AwsRegion

    return data.shortlinkDiscovery
  }

  return {
    discoverByReportPassword,
    discoverByShortlink,
    discoverByToken,
  }
}

export default useRegion
